export const environment = {
  production: false,
  baseUrl: 'https://api-f3lg4ta4ea-uc.a.run.app'
};
